import React, { useState, useEffect } from "react";
import PropertyList from "../components/Property/PropertyList"; // Assuming PropertyList component exists
import { useSearchParams } from "react-router-dom"; // To access the query parameters
import PropertyHeader from "../components/Parts/PropertyHeader";
import Footer from "../components/Parts/Footer";

const PropertyPage = () => {
  const [filters, setFilters] = useState({
    propertyType: "",
    minPrice: "",
    maxPrice: "",
    bedrooms: "",
    minArea: "",
    maxArea: "",
    isForSale: null,
    search:""
  });

  const [searchParams] = useSearchParams(); // Get the query parameters

  // Update filters based on the query parameters when PropertyPage loads
  useEffect(() => {
    setFilters({
      propertyType: searchParams.get("propertyType") || "",
      minPrice: searchParams.get("minPrice") || "",
      maxPrice: searchParams.get("maxPrice") || "",
      bedrooms: searchParams.get("bedrooms") || "",
      isForSale:
        searchParams.get("isForSale") === "true"
          ? true
          : searchParams.get("isForSale") === "false"
          ? false
          : null,
      minArea: searchParams.get("minArea") || "",
      maxArea: searchParams.get("maxArea") || "",
    });
  }, [searchParams]);

  return (
    <div>
      {/* Pass setFilters to PropertyHeader */}
      <PropertyHeader setFilters={setFilters} />

      {/* Pass the filters to the PropertyList component */}
      <PropertyList filters={filters} layout="dafault" />
      <Footer />
    </div>
  );
};

export default PropertyPage;
